import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const Container = styled.div`
`;

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
} from 'react-stripe-elements';

import './StripeInputForm.scss';
import ContractInfoItem from './ContractInfoItem';
import PayButton from './PayButton';
import {updateCard} from "../../../../api/api";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '18px',
      color: '#32325d',
      fontFamily: 'Source Code Pro, monospace',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

const StyledSection = styled.section`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const InfoItemContainer = styled(Container)`
  margin-bottom: 0;
`;

class StripeInputForm extends Component {
  constructor(props) {
    super(props);

    this.updateCard = this.updateCard.bind(this);

    this.state = {
      isLoading: false,
    };
  }

  async doUpdateCard(paymentMethod) {
    updateCard(this.props.contractId, paymentMethod.id, (err, result) => {
      this.setState({
        isLoading: false,
      });

      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`
        });
      } else {
        if (result.statusCode === "0" || result.statusCode === 0) {
          Messenger().post({
            type: 'success',
            message: 'Card Information Updated successfully!',
            showCloseButton: true,
          });
          this.props.closeModal({});
        } else {
          Messenger().post({
            type: 'error',
            message: `Failed to Update Card Information`
          });
        }
      }
    });
  }
  async updateCard() {
    this.setState({
      isLoading: true,
    });

    if (this.props.stripe && this.props.elements) {
      this.props.stripe.createPaymentMethod({
            type: 'card',
            card: this.props.elements.getElement('cardNumber'),
      }).then((payload) => {
        if (payload.error) {
          this.setState({
            isLoading: false,
          });
          Messenger().post({
            type: 'error',
            message: `Failed to create PaymentMethod: ${payload.error.message}`
          });
          console.log('[error]', payload.error);
        } else {
          this.doUpdateCard(payload.paymentMethod)
          console.log('[paymentMethod]', payload.paymentMethod);
        }
      });
    } else {
      Messenger().post({
        type: 'error',
        message: "Stripe.js hasn't loaded yet."
      });
      console.log("Stripe.js hasn't loaded yet.");
    }
  }


  handleChardNumberChange = (change) => {
    if(!change.empty && change.complete)
    {
      //completed
    }

    console.log('[card number change]', change);
  };

  handleExpireDateChange = (change) => {
    if(!change.empty && change.complete)
    {
      //completed
    }
    console.log('[expire date change]', change);
  };

  handleCvcDateChange = (change) => {
    if(!change.empty && change.complete)
    {
      //completed
    }
    console.log('[cvc change]', change);
  };


  render() {
    return (
        <div>
          <StyledSection>
              <InfoItemContainer>
                <ContractInfoItem
                    title="Card Number"
                    sub={
                      <CardNumberElement
                          onChange={this.handleChardNumberChange}
                          {...CARD_ELEMENT_OPTIONS}
                      />}
                />
                <ContractInfoItem
                    title="Expired Date"
                    sub={
                      <CardExpiryElement
                          onChange={this.handleExpireDateChange}
                          {...CARD_ELEMENT_OPTIONS}
                      />}
                />
                <ContractInfoItem
                    title="CVC"
                    sub={
                      <CardCVCElement
                          onChange={this.handleCvcDateChange}
                          {...CARD_ELEMENT_OPTIONS}
                      />}
                />
              </InfoItemContainer>
          </StyledSection>
          <PayButton onClick={this.updateCard} loading={this.state.isLoading} />
        </div>
    );
  }
}

StripeInputForm.propTypes = {
  contractId: PropTypes.number.isRequired
};

export default injectStripe(StripeInputForm);



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/EditCard/StripeInputForm.js